// extracted by mini-css-extract-plugin
module.exports = {"grayBackground":"FormInputRange_grayBackground__2adLX","grayTextColor":"FormInputRange_grayTextColor__1gqBX","grayBoxShadow":"FormInputRange_grayBoxShadow__3cGw9"};